require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-wallern-im-burgenland.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-wallern-im-burgenland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-wallern-im-burgenland!./.cache/json/betreuungseinrichtungen-neusiedl-wallern-im-burgenland.json
// module id = 966
// module chunks = 231608221292675